import getTarget from 'javascripts/utils/get-target';
import openDialog from 'javascripts/utils/open-dialog';
import DialogContent from 'components/organisms/dialog-content/DialogContent';
import { t } from 'javascripts/utils/withTranslation';

class Comment {
  constructor($el) {
    this.$el = $el;
    this.$truncatedText = this.$el.querySelector('.comment__text-preview');
    this.$functionButtons = this.$el.querySelectorAll('.comment__function');
    this.$flagButton = this.$el.querySelector('.comment__flag');

    if (this.$truncatedText) {
      $el.addEventListener('click', this.handleShowMore);
    }

    if (this.$functionButtons) {
      $el.addEventListener('click', this.handleFunctionClick);
    }
  }

  handleShowMore = (event) => {
    const target = getTarget(event.target, '.comment__toggle-link');

    if (target) {
      this.$el.classList.toggle('comment--collapsed');
    }
  }

  handleFunctionClick = (event) => {
    const target = getTarget(event.target, '.comment__function[href]');

    if (target && target.dataset.chosen !== 'true') {
      const value = parseInt(target.dataset.value, 10);
      const newValue = value + 1;

      // Reset existing chosen button (if one chosen.)
      this.$functionButtons.forEach(($el) => {
        const $button = $el;
        if ($button.dataset.chosen === 'true') {
          const chosenValue = parseInt($button.dataset.value, 10);
          const chosenNewValue = chosenValue - 1;
          $button.dataset.value = chosenNewValue;
          $button.querySelector('.comment__function-value').textContent = chosenNewValue;
          $button.dataset.chosen = '';
        }
      });

      target.dataset.chosen = 'true';
      target.dataset.value = newValue;
      target.querySelector('.comment__function-value').textContent = newValue;
    }
  }
}

function initFlagDialog() {
  const dialogSelectorClass = '.comment__flag';

  const dialogClasses = {
    scrollInnerClassName: 'comment-flag-dialog__scroll-inner',
    contentClassName: 'comment-flag-dialog__content',
  };

  const componentProps = {
    headline: { level: 3, text: t('Kommentar melden') },
    text: '<p>Möchten Sie diesen Kommentar wirklich als anstößig melden, weil er gegen die <a class="link link--external" href="/de/header-und-footer/netiquette/" target="_blank">Netiquette des Beteiligungsportals</a> verstößt?</p>',
    buttons: {
      alignment: 'right',
      items: [
        {
          text: t('Als anstößig melden'),
          link: '#',
        },
        {
          text: t('Nein'),
          style: 'secondary',
          isCloseButton: true,
        },
      ],
    },
  };
  openDialog(dialogSelectorClass, DialogContent, dialogClasses, componentProps);
}

initFlagDialog();

const componentStore = [];
document.querySelectorAll('.comment').forEach($el => componentStore.push(new Comment($el)));
